import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { MemberappBaseComponent } from "../../groupportal-base/groupportal-base.component";
import { MemberCounts, HeaderInfo } from "../../../../shared/models/group-portal-data.models";

declare var $: any;
@Component({
	selector: 'provider-status-dashboard',
	templateUrl: './provider-status-dashboard.component.html'
})

export class ProviderStatusDashboardComponent extends MemberappBaseComponent {
	@Input() showChart = false;
	@ViewChild('dataContainer') dataContainer: ElementRef;
	@Input() mbrCount: MemberCounts;
	@Input() groupList: any;
	// pieslicePaid = 0;
	// pieslicePending = 0;
	// piesliceReadyForPayment = 0;
	// piesliceNotInGB = 0;
	// sumPie = 0;
	// percentofPieSlicePaid: number = 0;
	// percentofPieSlicePending: number = 0;
	// percentofPieSliceReadyForPayment: number = 0;
	// percentofPieSliceNotInGB: number = 0;
	// strokeoffsetPaid: number = 0;
	// strokeoffsetPending: number = 0;

	// strokeoffsetReadyForPayment: number = 0;
	// strokeoffsetNotInGB: number = 0;

	initSubscriptions() {
		// this.groupPortalDataService.getMemberCounts().subscribe(
		// 	mbrCount => {
		// 		this.dingPieReady(mbrCount);
		// 		//this.makeAPieChart(mbrCount);
		// 	}
		// );
	}
	ngOnInit() {

	}
	ngAfterViewInit() {

	}

}

